import styles from 'styles/views/widgets/IconButton.css';
import React, { Component, PropTypes } from 'react';
import Button from './Button';

export default class IconButton extends Component {
  static propTypes = {
    children: PropTypes.node
  };

  render () {
    let {children, ...otherProps} = this.props;
    return (
      <Button
        className={styles.button}
        {...otherProps}>
        {children}
      </Button>
    );
  }
}



/** WEBPACK FOOTER **
 ** ./src/views/widgets/IconButton.js
 **/